var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":_vm.cellSize,"width":_vm.cellSize,"draggable":!!_vm.chessInCell,"color":_vm.row <= 4
      ? 'grey'
      : (_vm.row + _vm.col) % 2 === 0
      ? _vm.highlighted
        ? 'green darken-1'
        : 'green lighten-4'
      : _vm.highlighted
      ? 'green darken-3'
      : 'green lighten-2',"img":_vm.chessInCell ? _vm.imageSource() : null},on:{"dblclick":_vm.withdrawChess,"dragstart":_vm.drag,"dragenter":_vm.dragenter,"dragleave":_vm.dragleave,"dragover":function($event){$event.preventDefault();return _vm.dragover($event)},"drop":_vm.drop,"touchstart":_vm.touchstart,"touchend":_vm.touchend}},[(!!_vm.chessInCell)?_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',[_vm._v(" "+_vm._s('⭐'.repeat(_vm.chessInCell.star))+" ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }